import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { Character } from '@/types/scriptAnalysis';
import { getConfidenceLevel } from '@/types/scriptAnalysis';

interface CharacterListProps {
  characters: Character[];
}

const confidenceConfig = {
  high: {
    label: 'Alta',
    className: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-400 border-transparent',
  },
  medium: {
    label: 'Media',
    className: 'bg-amber-50 text-amber-600 dark:bg-amber-950 dark:text-amber-400 border-transparent',
  },
  low: {
    label: 'Baja',
    className: 'bg-red-50 text-red-600 dark:bg-red-950 dark:text-red-400 border-transparent',
  },
};

const typeConfig = {
  speaking: { label: 'Principal', variant: 'default' as const },
  extra: { label: 'Extra', variant: 'secondary' as const },
  mentioned: { label: 'Mencionado', variant: 'outline' as const },
};

export function CharacterList({ characters }: CharacterListProps) {
  return (
    <TooltipProvider>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead scope="col">Personaje</TableHead>
            <TableHead scope="col">Tipo</TableHead>
            <TableHead scope="col">Escenas</TableHead>
            <TableHead scope="col">Confianza</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {characters.map((character) => {
            const level = getConfidenceLevel(character.confidence);
            const conf = confidenceConfig[level];
            const type = typeConfig[character.type];

            return (
              <TableRow key={character.id}>
                <TableCell className="font-medium">{character.name}</TableCell>
                <TableCell>
                  <Badge variant={type.variant}>{type.label}</Badge>
                </TableCell>
                <TableCell>{character.scene_ids.length}</TableCell>
                <TableCell>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Badge className={conf.className}>
                        {conf.label}
                      </Badge>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>
                        Confianza de la IA: {(character.confidence * 100).toFixed(0)}% - Los elementos marcados como borrador requieren revision manual.
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TooltipProvider>
  );
}
